import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-food-additives-dialog',
  templateUrl: './food-additives-dialog.component.html',
  styleUrls: ['./food-additives-dialog.component.css']
})
export class FoodAdditivesDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
